import { Color, ColorDynamic } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const DeliveryAltIcon = createSvgIcon(
  'PostingFilterDeliver',
  <>
    <rect x="2" y="2" width="20" height="20" rx="4" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.9132L8.19591 11.6956L11.1621 14.7316V6H12.8379V14.7316L15.8041 11.6956L17 12.9132L11.9961 18L7 12.9132Z"
      fill={ColorDynamic.White}
    />
  </>,
);

export const DeliveryAltIconWhite = createSvgIcon(
  'PostingFilterDeliver',
  <>
    <rect x="2" y="2" width="20" height="20" rx="4" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.9132L8.19591 11.6956L11.1621 14.7316V6H12.8379V14.7316L15.8041 11.6956L17 12.9132L11.9961 18L7 12.9132Z"
      fill={Color.White}
    />
  </>,
);
